<div class="form-field__label form-field__label--external">
  @if (field?.label; as label) {
    {{ label | translateInline }}
  }
</div>
@for (item of items$ | async; track item.value) {
  <div class="form-field__checkbox-group-item">
    <label class="form-field__checkbox" (click)="toggleChecked(item)">
      <fa-icon
        [icon]="isChecked(item) ? iconChecked : iconUnchecked"
        class="form-field__checkbox-icon"
        [class.form-field__checkbox-icon--checked]="isChecked(item)"
        [class.form-field__checkbox--error]="showError"
      ></fa-icon>

      <div>
        <div
          class="form-field__checkbox-label form-field__checkbox-group-label"
          [class.form-field__checkbox--error]="showError"
        >
          {{ item.label | translateInline }}
        </div>
        @if (item.description) {
          @let description = item.description | translateInline;
          @if (description) {
            <div class="form-field__checkbox-description">
              {{ description }}
            </div>
          }
        }
      </div>
    </label>
  </div>
}
<div class="form-field__error-message">
  @if (showError && control.errors) {
    <div>
      {{ control.errors | declarativeErrorMessage: field : declaration }}
    </div>
  }
</div>
